  
  const About = () => (
    <div className="content-text">
      <h1>Um Barbörukórinn</h1>
      <p>Barbörukórinn var stofnaður vorið 2007 af Guðmundi Sigurðssyni, þáverandi organista Hafnarfjarðarkirkju. Kórinn dregur nafn sitt af heilagri Barböru en stytta af dýrlingnum fannst í Kapelluhrauni árið 1950. Titillag plötunnar fjallar um heilaga Barböru og var sérstaklega samið fyrir kórinn af Huga Guðmundssyni við ljóð Þórarins Eldjárns. Að auki eru fjögur verk eftir Auði Guðjohnsen á plötunni, en hún er meðlimur í kórnum. Barbörukórinn kemur reglulega fram við helgihald í Hafnarfjarðarkirkju auk tónleikahalds og söngs við útfarir víða um höfuðborgarsvæðið.</p>
    </div>
  );
  
  export default About;
